import {Typography} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import {ThemeProvider} from "@material-ui/styles";
import * as Keycloak from 'keycloak-js';
import React, {useContext} from 'react';
import Header from '../../components/shared/layout/header';
import theme from '../../components/theme/index';
import Oval from '../../images/oval.svg';
import LogoSebrae from '../../images/slogo-cinza.png';
import useStyles from './styles';
import {AppContext} from "../../components/shared/context";

const Home = () => {
  const classes = useStyles();
  const keycloak = Keycloak('/keycloak.json');
  keycloak.init({ flow: 'implicit' });

  const { protocol, host } = window.location
  let redirectUri = `${protocol}//${host}/concluir-cadastro`

  const { tokenParsed } = keycloak;

  const { role } = useContext(AppContext);

  if (tokenParsed && role) {
    redirectUri = `${protocol}//${host}/quem-e-quem`
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <div>
          <Header />
          <div className={classes.landing}>
            <div className={classes.retangulo}>
              <div className={classes.mensagem}>
                <Typography className={classes.saudacao}>
                  Bem vindo ao
                  {' '}
                  <br />
                  {' '}
                  Portal dos Conselhos
                </Typography>
                <Typography className={classes.info}>
                  O portal foi criado para ajudar a organizar e notificar sobre reuniões e encontros que tratam de
                  assuntos
                  de
                  interesse do Conselho. Aqui conselheiros e colaboradores tem acesso a documentos, atas e outros
                  registros
                  relevantes para as reuniões, futuras ou passadas.
                </Typography>

              </div>
              <div>
                <img style={{ position: 'fixed', left: '66%' }} src={Oval} alt="" />
                <div className={classes.paper}>
                  <div className={classes.paperContent}>
                    <div style={{ marginTop: '46px' }}>
                      <img className={classes.logoSebrae} src={LogoSebrae} alt="" />
                    </div>
                    <div style={{ marginTop: '32px', marginBottom: '27px' }}>
                      <Typography className={classes.paperTitle}>
                        Acesse com a sua conta Sebrae
                      </Typography>
                    </div>
                    <div style={{ width: '413px' }}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={() => keycloak.login({ redirectUri })}
                      >
                        Faça o seu Login
                      </Button>
                    </div>
                    <div className={classes.ouSection}>
                      <div className={classes.divisor} style={{ marginRight: '11px' }} />
                      <Typography className={classes.ou}> ou </Typography>
                      <div className={classes.divisor} style={{ marginLeft: '11px' }} />
                    </div>
                    <div className={classes.footer}>
                      <Link
                        onClick={() => keycloak.login({ action: 'register' })}
                        className={classes.link}
                      >
                        Cadastre-se Agora
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ThemeProvider>
    </>
  );
}

export default Home;
